import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";

let amplitudeApiKey;
if (window._siteProps_?.props?.amplitudeApiKey) {
  amplitudeApiKey = window._siteProps_?.props?.amplitudeApiKey;
} else {
  amplitudeApiKey = "eb5620e68d5fa570a077fcf9cde1080d";
  if (window._siteProps_?.props?.build_env_var === "production") {
    amplitudeApiKey = "22b51b98c3b678e3bb43761e835025fb";
  }
}

let amplitudeConfigObj = {
  saveEvents: true,
  includeUtm: true,
  includeReferrer: true,
  saveParamsReferrerOncePerSession: false,
  unsetParamsReferrerOnNewSession: true,
};

var getAmpUserProperties = function () {
  let nghUtmSourceMedium = "";
  let queryParams = Utility.getQueryFromUrl();
  if (queryParams["utm_source"] && queryParams["utm_medium"]) {
    nghUtmSourceMedium =
      queryParams["utm_source"] + "-" + queryParams["utm_medium"];
  }

  const userAgent = window?.navigator?.userAgent || "";
  let deviceType = "desktop";
  if (/mobi|android/i.test(navigator?.userAgent?.toLowerCase() || "")) {
    deviceType = "mobile";
  } else if (/ipad|tablet/i.test(navigator?.userAgent?.toLowerCase() || "")) {
    deviceType = "tablet";
  }

  let landingPage = Utility.tryJsonParse(
    sessionStorage.LANDING_PAGE_FOR_NEXTGEN
  );
  if (landingPage == "/") {
    landingPage = "home";
  }
  try {
    landingPage =
      landingPage?.trim()?.replace(/^\/+/, "")?.replace(/\/+$/, "") || "home";
  } catch (e) {
    landingPage = "home";
  } finally {
    LocalStorageFunc.setSessionStorageKey(
      "LANDING_PAGE_FOR_NEXTGEN",
      landingPage
    );
  }

  let orderType = LocalStorageFunc.getDeliveryType();

  let networkType = navigator?.connection?.effectiveType || "N/A";
  let screenSize = `${window.screen.width}x${window.screen.height}`;
  let screenResolution = `${window.screen.width * window.devicePixelRatio}x${
    window.screen.height * window.devicePixelRatio
  }`;

  return {
    utmSourceMedium: nghUtmSourceMedium,
    userAgent: userAgent,
    deviceType: deviceType,
    landingPage: landingPage,
    networkType: networkType,
    screenSize: screenSize,
    screenResolution: screenResolution,
    Order_type: orderType,
  };
};

export default {
  amplitudeApiKey,
  amplitudeConfigObj,
  getAmpUserProperties,
};
